import type { SessionUser } from "../auth/useSession";

export function canManageMembers(
  user: SessionUser | null | undefined,
): boolean {
  return activeMembershipDecision(user, "can_manage_members");
}

export function canManageSources(
  user: SessionUser | null | undefined,
): boolean {
  return activeMembershipDecision(user, "can_manage_sources");
}

export function canManageDataQuality(
  user: SessionUser | null | undefined,
): boolean {
  return activeMembershipDecision(user, "can_manage_data_quality");
}

export function canUseLegacyIdentityReview(
  user: SessionUser | null | undefined,
): boolean {
  return activeMembershipDecision(user, "can_use_legacy_identity_review");
}

function activeMembershipDecision(
  user: SessionUser | null | undefined,
  key:
    | "can_manage_members"
    | "can_manage_sources"
    | "can_manage_data_quality"
    | "can_use_legacy_identity_review",
): boolean {
  if (!user?.active_membership) return false;
  if (user.active_membership.tenant_slug !== user.customer_id) return false;
  return user.active_membership[key];
}
